export type Education = {
  id: EducationLevel;
  displayName: string;
  slug: string;
};

export enum EducationLevel {
  First = 'FIRST',
  None = 'NONE',
  Second = 'SECOND',
  Third = 'THIRD'
}
